import api from './axiosInstance';

export const login = async (email, password) => {
    const response = await api.post("/login", { email, password });
    localStorage.setItem('accessToken', response.data.accessToken);
    localStorage.setItem('refreshToken', response.data.refreshToken);
    return response.data;
};

export const register = async (name, email, password) => {
    try {
        return await api.post("/register", { name, email, password });
    } catch (error) {
        throw new Error(error.response.data.message);
    }
};

export const changePassword = async (email, oldPassword, newPassword) => {
    const response = await api.post("/change-password", { email, oldPassword, newPassword });
    localStorage.setItem('accessToken', response.data.accessToken);
    localStorage.setItem('refreshToken', response.data.refreshToken);
    return response.data;
};

export const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await api.post("/refresh-token", { refreshToken });
    localStorage.setItem('accessToken', response.data.accessToken);
    return response.data.accessToken;
};

export const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
};

export const googleOAUTHRedirect = async (credentials) => {
    return api.post("/google/connect", credentials );
};

export const updateCurrency = async (userId, newCurrency) => {
    try {
        const response = await api.post("/update-currency", { userId, newCurrency });
        return response.data;
    }
    catch (error) {
        throw new Error(error.response.data.message);
    }
}